import { useState, useEffect, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SearchInput, SelectPerPage } from '../../common/Forms/Input/Input';
import {
  GiftcardTables,
  GiftcardParticularTables,
} from '../../common/Tables/Tables';
import {
  giftcardSalesheader,
  giftcardParticularSalesheader,
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { saleChannelService } from '../../../services/saleChannelService';
import { campaignService } from '../../../services/campaignService';
import { membershipCatalogService } from '../../../services/membershipCatalogService';
import { giftCardService } from '../../../services/giftCardService';
import { paymentsService } from '../../../services/paymentsService.js';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../assets/schemas/schemas';
import { Select, FilterDatePicker } from '../../common/Forms/Input/Input';
import { useHistory } from 'react-router-dom';
import authService from '../../../services/authService.js';
import { salesRoles } from '../../../assets/helpers/roles.js';
import { capitalize, filterParams } from '../../../assets/helpers/funciones';
import {
  codeStatusOptions,
  discountTypeOptions,
  giftCardTypeOptions,
  idCodes,
  phoneCodes,
  giftCardType,
  ExportableOtpModules,
  transactionTypes,
} from '../../../assets/helpers/options';
import {
  CreateGiftcardModal,
  DeleteGiftcardModal,
  VerifyPaymentModal,
  EditGiftcardModal,
  OtpModal,
} from '../../common/Modals/Modals';
import moment from 'moment';
import './Giftcards.scss';
import { usersService } from '../../../services/usersService.js';
import { productService } from '../../../services/productService.js';
import { rateService } from '../../../services/rateService.js';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];

export const Giftcards = () => {
  const tableRef = useRef(null);
  const history = useHistory();
  const [dateFrom, setDateFrom] = useState(new Date());
  const [dateTo, setDateTo] = useState(new Date());

  const [isLoading, setIsloading] = useState(false);
  const [limitGiftcard, setLimitGiftcard] = useState('');
  const [selectedVerifiedPayment, setSelectedVerifiedPayment] = useState('');
  const [publicCodes, setPublicCodes] = useState([]);
  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [campaignsOptions, setCampaignsOptions] = useState([]);
  const [membershipOptions, setMembershipOptions] = useState([]);
  const [giftcardType, setGifcardType] = useState('Particular');
  const [dollarRate, setDollarRate] = useState(1);
  const [fileUploaded, setFileUploaded] = useState([]);
  const [otpCode, setOtpCode] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [channels, setChannels] = useState([]);
  const [channelsOptions, setChannelsOptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [plansOptions, setPlansOptions] = useState([]);
  const [codes, setCodes] = useState([]);
  const [codesOptions, setCodesOptions] = useState([]);
  const [sellersFilter, setsellersFilter] = useState([]);
  const [sellersFilterOptions, setSellersFilterOptions] = useState([]);
  const [createCodeModal, setCreateCodeModal] = useState({
    isOpen: false,
  });
  const [deleteCodeModal, setDeleteCodeModal] = useState({
    isOpen: false,
    selected: '',
  });

  const [verifyPaymentModal, setVerifyPaymentModal] = useState({
    isOpen: false,
    selected: '',
  });

  const [editCodeModal, setEditCodeModal] = useState({
    isOpen: false,
    selected: '',
  });
  const [sellers, setSellers] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const exportDataTable = () => {
    let retailParams = {
      limit: dataTable?.limit,
      offset: dataTable?.page,
      saleType: giftcardType,
      byEmail: true,
    };

    let particularParams = {
      limit: dataTable?.limit,
      page: dataTable?.page,
      dateFrom: dateFrom ? moment(dateFrom).format('YYYY-MM-DD') : '',
      dateTo: dateTo ? moment(dateTo).format('YYYY-MM-DD') : '',
      saleType: giftcardType,
      byEmail: true,
    };
    if (giftcardType === giftCardType?.PARTICULAR) {
      if (
        ![
          salesRoles?.SALES_ADMIN,
          salesRoles?.SALES_ADMIN_AUX,
          salesRoles?.SALES_DEVELOPER,
          salesRoles?.SALES_SUPERVISOR,
        ].includes(authService?.getUserType()) &&
        particularParams.byEmail === true
      ) {
        particularParams.otp = otpCode;
      }

      if (channelsOptions.length > 0) {
        particularParams.channels = channelsOptions;
      }
      if (codesOptions.length > 0) {
        let selectedCodes = [];
        codesOptions.forEach((code) => {
          selectedCodes.push(Number(code));
        });
        particularParams.publicCodes = selectedCodes;
      }
      if (plansOptions.length > 0) {
        particularParams.plans = plansOptions;
      }
      if (sellersFilterOptions.length > 0) {
        particularParams.sellers = sellersFilterOptions;
      }
    }

    if (giftcardType === giftCardType?.PARTICULAR) {
      giftCardService
        .giftCardSales(particularParams)
        .then((response) => {
          if (response.status === 200) {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          } else {
            notify(`${response.message}` || 'error', 'error');
            setDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    } else {
      giftCardService
        .getGiftCards(retailParams)
        .then((response) => {
          if (response.status === 200) {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          } else {
            notify(`${response.message}` || 'error', 'error');
            setDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }
    return true;
  };

  const [dataTable, setDataTable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    sinceDate: '',
    untilDate: '',
    isLoading: true,
  });

  const formatSellers = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: arr[i]?.firstName + ' ' + arr[i]?.lastName,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const handleSellerFilter = (arr) => {
    setSellersFilterOptions(arr);
  };

  const formatCodes = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: arr[i]?.toString(),
        _id: arr[i]?.toString(),
      });
    }
    // sort by less _id to higher _id
    data = data.sort((a, b) => a._id - b._id);
    return data;
  };

  const handleCodeOptions = (arr) => {
    setCodesOptions(arr);
  };

  const formatPlans = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: arr[i]?.code,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const handlePlansOptions = (arr) => {
    setPlansOptions(arr);
  };

  const formatChannels = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: arr[i]?.shortName,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const handleChannelsOptions = (arr) => {
    setChannelsOptions(arr);
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const setFirstPage = () => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    getValues: getValues2,
    resetField: resetField2,
    reset: reset2,
    watch: watch2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.editGiftcardSaleSchema()),
  });
  const onSubmit2 = handleSubmit2(async (data) => {
    let dataToPost = { ...data };
    // validateLimitGiftcards();

    delete dataToPost?.channel;
    delete dataToPost?.membership;
    delete dataToPost?.publicCode;

    const formData = new FormData();

    if (dataToPost?.saleType === giftCardType?.PARTICULAR) {
      // delete dataToPost.saleQuantity;
      // dataToPost.customer = {
      //   firstName: dataToPost?.firstName,
      //   lastName: dataToPost?.lastName,
      //   identificationType: dataToPost?.identificationType,
      //   identification: dataToPost?.identification,
      //   phonePrefix: dataToPost?.phonePrefix,
      //   phoneNumber: dataToPost?.phoneNumber,
      //   email: dataToPost?.email,
      // };

      formData.append('seller', dataToPost?.seller);
      formData.append('saleDate', dataToPost?.saleDate);
      formData.append('planAmount', dataToPost?.planAmount);
      formData.append('customer[firstName]', dataToPost?.firstName);
      formData.append('customer[lastName]', dataToPost?.lastName);
      formData.append(
        'customer[identificationType]',
        dataToPost?.identificationType
      );
      formData.append('customer[identification]', dataToPost?.identification);
      formData.append('customer[phonePrefix]', dataToPost?.phonePrefix);
      formData.append('customer[phoneNumber]', dataToPost?.phoneNumber);
      formData.append('customer[email]', dataToPost?.email);

      formData.append('includesRcv', dataToPost?.includesRcv ? true : false);
      formData.append('unlimitedKm', dataToPost?.unlimitedKm ? true : false);
      formData.append(
        'armorSurcharge',
        dataToPost?.armorSurcharge ? true : false
      );
      formData.append(
        'extraKmSurcharge',
        dataToPost?.extraKmSurcharge ? true : false
      );
      formData.append(
        'classSurcharge',
        dataToPost?.classSurcharge ? true : false
      );
      formData.append(
        'yearSurcharge',
        dataToPost?.yearSurcharge ? true : false
      );

      if (dataToPost.paymentMethods > 0) {
        formData.append('payments[0][method]', dataToPost?.method0);
        formData.append('payments[0][amount]', dataToPost?.amount0);
        formData.append('payments[0][amountBsS]', dataToPost?.amountBsS0);
        formData.append('payments[0][reference]', dataToPost?.reference0);
      }
      if (dataToPost.paymentMethods > 1) {
        formData.append('payments[1][method]', dataToPost?.method1);
        formData.append('payments[1][amount]', dataToPost?.amount1);
        formData.append('payments[1][amountBsS]', dataToPost?.amountBsS1);
        formData.append('payments[1][reference]', dataToPost?.reference1);
      }
      if (fileUploaded[0]) {
        formData.append(
          'payments[0][imgChanged]',
          fileUploaded[0].inputUploaded === 0 ? true : false
        );
        formData.append('paymentEvidence', fileUploaded?.[0]?.file);
      }
      if (fileUploaded[1]) {
        formData.append(
          'payments[1][imgChanged]',
          fileUploaded[1].inputUploaded ? true : false
        );
        formData.append('paymentEvidence', fileUploaded?.[1]?.file);
      }
    }

    if (dataToPost?.saleType === giftCardType?.RETAIL) {
      delete dataToPost.publicCode;
      if (dataToPost.saleQuantity === '0') {
        notify(`No existen tarjetas activas dispobibles`, 'info');
        return null;
      }
    }

    delete dataToPost.firstName;
    delete dataToPost.lastName;
    delete dataToPost.identificationType;
    delete dataToPost.identification;
    delete dataToPost.phonePrefix;
    delete dataToPost.phoneNumber;
    delete dataToPost.email;

    if (!isLoading) {
      setIsloading(true);
      giftCardService
        .editGiftcardSale(
          filterParams(
            dataToPost?.saleType === giftCardType?.PARTICULAR
              ? formData
              : dataToPost
          ),
          editCodeModal?.selected?._id
        )
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Giftcard editada con éxito`, 'success');
            setIsloading(false);
            handleEditCodeForm();
            reset2();
            setFileUploaded([]);
            getCodes();
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getActiveGiftcards = (saleChannelId, type, membership) => {
    setLimitGiftcard('');
    setValue2('saleQuantity', 0);
    setPublicCodes([]);

    let params = {
      saleChannel: saleChannelId,
      type: type,
      membership: membership,
    };

    if (saleChannelId && type) {
      if (type === 'Retail' && !membership) {
        return null;
      }

      giftCardService
        .getActiveGiftcards(params)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setLimitGiftcard(response?.data?.quantity);
            setValue2('saleQuantity', response?.data?.quantity);
            if (response?.data?.publicCodes?.length > 0) {
              let data = [];
              for (let i = 0; i < response?.data?.publicCodes.length; i++) {
                data.push({
                  name: `${response?.data?.publicCodes[i]?.publicCode}`,
                  _id: response?.data?.publicCodes[i]?.publicCode,
                  membershipId: response?.data?.publicCodes[i]?.membershipId,
                });
              }
              data = data?.filter((d) => d?.membershipId === membership);
              setPublicCodes(data);
            }
          } else {
            notify(`${response.message}` || 'error', 'error');
            setLimitGiftcard('0');
            setValue2('saleQuantity', 0);
            notify(`No existen tarjetas activas dispobibles`, 'info');
          }
        })
        .catch(() => {});
    }
  };

  const selectPublicCode = () => {
    let [filtered] = publicCodes?.filter((p) => p?._id == watch2('publicCode'));
    setValue2('membership', filtered?.membershipId);
  };

  const preloadForm = (code) => {
    setValue2('saleType', code?.saleType);
    setValue2('channel', code?.channel?.shortName);
    setValue2('membership', capitalize(code?.membership?.code));
    setValue2('publicCode', code?.publicCode);
    setValue2('planAmount', code?.planAmount);
    setValue2('saleQuantity', code?.saleQuantity);
    setValue2('status', code?.status);
    setValue2('saleDate', new Date(code?.saleDate));
    setValue2('firstName', code?.customer?.firstName);
    setValue2('lastName', code?.customer?.lastName);
    setValue2('identificationType', code?.customer?.identificationType);
    setValue2('identification', code?.customer?.identification);
    setValue2('phonePrefix', code?.customer?.phonePrefix);
    setValue2('phoneNumber', code?.customer?.phoneNumber);
    setValue2('email', code?.customer?.email);
    setValue2('includesRcv', code?.includesRcv);
    setValue2('unlimitedKm', code?.unlimitedKm);
    setValue2('extraKmSurcharge', code?.extraKmSurcharge);
    setValue2('yearSurcharge', code?.yearSurcharge);
    setValue2('classSurcharge', code?.classSurcharge);
    setValue2('armorSurcharge', code?.armorSurcharge);
    setValue2('seller', code.seller._id);
    if (code.pay1Amount && code.pay2Amount) {
      setValue2('paymentMethods', '2');
    } else if (code.pay1Amount) {
      setValue2('paymentMethods', '1');
    } else {
      setValue2('paymentMethods', '0');
    }
    setValue2('method0', code?.payments?.[0]?.method?._id);
    setValue2('amount0', code?.pay1Amount);
    setValue2('amountBsS0', code?.pay1AmountBs);
    setValue2('reference0', code?.pay1Reference);
    setValue2('refImg0', code?.payments?.[0]?.referenceImg);
    setValue2('method1', code?.payments?.[1]?.method?._id);
    setValue2('amount1', code?.pay2Amount);
    setValue2('amountBsS1', code?.pay2AmountBs);
    setValue2('reference1', code?.pay2Reference);
    setValue2('refImg1', code?.payments?.[1]?.referenceImg);
  };

  const closeEditModal = () => {
    handleEditCodeForm();
    reset2();
    setFileUploaded([]);
  };

  const selectitemsPerpage = (event) => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const validateLimitGiftcards = () => {
    if (
      watch2('saleQuantity') &&
      limitGiftcard &&
      parseFloat(watch2('saleQuantity')) > limitGiftcard
    ) {
      notify('No puede superar el limite de tarjetas permitidas', 'info');
      setValue2('saleQuantity', limitGiftcard);
    }
    return null;
  };

  const handlePageChange = (event, value) => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * dataTable?.limit,
      };
    });
  };

  const redirectToOrder = (orderId) => {
    history.push(`/afiliations/order/${orderId}`);
  };

  const validateUserRole = () => {
    let user = authService?.getUser();

    if (
      user?.roles[0]?.code === salesRoles?.SALES_COUNTER &&
      user?.type === 'Externo'
    ) {
      history?.push('/dashboard/analytics');
    }
  };

  useEffect(() => {
    getCodes();
  }, [
    dataTable?.page,
    dataTable?.offset,
    dataTable?.limit,
    dataTable?.type,
    dataTable?.sinceDate,
    dataTable?.untilDate,
    giftcardType,
    dateFrom,
    dateTo,
    channelsOptions,
    codesOptions,
    plansOptions,
    sellersFilterOptions,
  ]);

  useEffect(() => {
    getSellers();
    getPaymentMethods();
    getCodes();
    getSalesChannel();
    getAvailableMemberships();
    getCampaigns();
    validateUserRole();
    getDollarRate();
  }, []);

  const getSalesChannel = () => {
    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setSalesChannelOptions(response?.data?.saleChannels);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getCampaigns = () => {
    campaignService
      .getCampaigns()
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setCampaignsOptions(response?.data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const handleGiftcardType = (e) => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        data: [],
        count: 0,
        isLoading: false,
      };
    });
    setGifcardType(e?.target?.value);
  };

  const getAvailableMemberships = () => {
    membershipCatalogService
      .getAvailableMemberships()
      .then((response) => {
        let data = [];
        for (let i = 0; i < response?.data?.length; i++) {
          data.push({
            name: response?.data[i]?.code,
            _id: response?.data[i]?._id,
          });
        }
        if ([200, 201].includes(response?.status)) {
          setMembershipOptions(data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const deleteGiftcardLoad = () => {
    giftCardService
      .deleteGiftCardSales(deleteCodeModal?.selected?._id)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          handleDeleteGiftcardModal();
          getCodes();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const verifyPaymentAction = () => {
    paymentsService
      .validatePayment({ id: selectedVerifiedPayment?._id })
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          notify('Pago verificado con éxito', 'success');
          handleVerifyPaymentModal();
          setSelectedVerifiedPayment('');
          getCodes();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const selectVerifiedPayment = (id) => {
    setSelectedVerifiedPayment(id);
  };

  const getDollarRate = async () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getSellers = () => {
    usersService
      .getSalesUsers({
        status: 'Activo',
        module: 'Ventas',
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.length === 0) {
            notify('No hay asesores disponibles', 'info');
          }
          const cleanData = formatSellers(response?.data.users);
          setSellers(cleanData);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => {
        notify('Error al consultar asesores', 'error');
      });
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getCodes = () => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        data: [],
        count: 0,
        isLoading: true,
      };
    });
    let particularParams = {
      limit: dataTable?.limit,
      page: dataTable?.page,
      dateFrom: dateFrom ? moment(dateFrom).format('YYYY-MM-DD') : '',
      dateTo: dateTo ? moment(dateTo).format('YYYY-MM-DD') : '',
      saleType: giftcardType,
    };

    if (giftcardType === giftCardType?.PARTICULAR) {
      if (channelsOptions.length > 0) {
        particularParams.channels = channelsOptions;
      }
      if (codesOptions.length > 0) {
        let selectedCodes = [];
        codesOptions.forEach((code) => {
          selectedCodes.push(Number(code));
        });
        particularParams.publicCodes = selectedCodes;
      }
      if (plansOptions.length > 0) {
        particularParams.plans = plansOptions;
      }
      if (sellersFilterOptions.length > 0) {
        particularParams.sellers = sellersFilterOptions;
      }
      if(dataTable?.searchParam !== ''){
        particularParams.search = dataTable?.searchParam;
      }
    }

    let retailParams = {
      limit: dataTable?.limit,
      offset: dataTable?.page,
      saleType: giftcardType,
    };
    if (giftcardType === giftCardType?.PARTICULAR) {
      giftCardService
        .giftCardSales(filterParams(particularParams))
        .then((response) => {
          if (response.status === 200) {
            const shouldLoadFilterOptions =
              dataTable?.offset === 0 &&
              (channels.length === 0 ||
                codes.length === 0 ||
                plans.length === 0 ||
                sellersFilter.length === 0);
            if (shouldLoadFilterOptions) {
              const filterOptions = response.data?.filters[0] || {};
              setChannels(formatChannels(filterOptions?.channels));
              setCodes(formatCodes(filterOptions?.publicCodes));
              setPlans(formatPlans(filterOptions?.plans));
              setsellersFilter(formatSellers(filterOptions?.sellers));
            }
            setDataTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.giftCardSales,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
            setDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    if (giftcardType === giftCardType?.RETAIL) {
      giftCardService.getGiftCards(retailParams).then((response) => {
        if (response.status === 200) {
          setDataTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.giftCardSales,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || 'error', 'error');
          setDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      });
    }
    return true;
  };

  const redirectToEdit = (id) => {
    history.push(`/module/${transactionTypes.EDIT_GIFTCARD}/${id}`);
  };

  const openDetail = (fleet) => {
    history.push(`/modules/fleet-register/detail/${fleet?._id}`);
  };

  const handleCreateCodeForm = () => {
    setCreateCodeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !createCodeModal?.isOpen,
      };
    });
  };

  const handleSearchChange = (event) => {
    setDataTable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
        data: false,
      };
    });
  };

  const cleanFilters = () => {
    setChannelsOptions([]);
    setCodesOptions([]);
    setPlansOptions([]);
    setSellersFilterOptions([]);
  };

  const handleEditCodeForm = (code) => {
    setEditCodeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !editCodeModal?.isOpen,
        selected: code ? code : '',
      };
    });
    if (code) {
      preloadForm(code);
    }
  };

  const handleDeleteGiftcardModal = (giftcard) => {
    setDeleteCodeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !deleteCodeModal?.isOpen,
        selected: giftcard ? giftcard : '',
      };
    });
  };

  const handleVerifyPaymentModal = (giftcard) => {
    if (selectedVerifiedPayment) {
      setSelectedVerifiedPayment('');
    }

    setVerifyPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !verifyPaymentModal?.isOpen,
        selected: giftcard ? giftcard : '',
      };
    });
  };

  const showOtp = () => {
    if (!otpCode && !isLoading) {
      authService
        .sendOtp({ module: ExportableOtpModules.GIFTCARD_SALES })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify('Ingrese el código OTP enviado a su correo', 'Success');
            setShowOtpModal(true);
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    }
  };

  return (
    <>
      <LoadSpinner show={dataTable?.isLoading} />
      <CreateGiftcardModal
        modal={createCodeModal}
        handleModal={handleCreateCodeForm}
        getCodes={getCodes}
        rate={dollarRate}
        options={{
          salesChannelOptions: salesChannelOptions,
          codeStatusOptions: codeStatusOptions,
          discountTypeOptions: discountTypeOptions,
          membershipOptions: membershipOptions,
          campaignsOptions: campaignsOptions,
          giftCardTypeOptions: giftCardTypeOptions,
          idCodes: idCodes,
          sellers: sellers,
          paymentMethods: paymentMethods,
          phoneCodes: phoneCodes,
        }}
      />

      <EditGiftcardModal
        modal={editCodeModal}
        handleModal={handleEditCodeForm}
        getCodes={getCodes}
        rate={dollarRate}
        register={register2}
        setValue={setValue2}
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        watch={watch2}
        control={control2}
        errors={errors2}
        reset={reset2}
        action={onSubmit2}
        close={closeEditModal}
        onChange={{
          getActiveGiftcards: getActiveGiftcards,
          validateLimitGiftcards: validateLimitGiftcards,
          selectPublicCode: selectPublicCode,
        }}
        options={{
          salesChannelOptions: salesChannelOptions,
          codeStatusOptions: codeStatusOptions,
          discountTypeOptions: discountTypeOptions,
          membershipOptions: membershipOptions,
          campaignsOptions: campaignsOptions,
          giftCardTypeOptions: giftCardTypeOptions,
          idCodes: idCodes,
          phoneCodes: phoneCodes,
          publicCodes: publicCodes,
          limitGiftcard: limitGiftcard,
          sellers: sellers,
          paymentMethods: paymentMethods,
        }}
      />

      <DeleteGiftcardModal
        modal={deleteCodeModal}
        handleModal={handleDeleteGiftcardModal}
        action={deleteGiftcardLoad}
      />

      <VerifyPaymentModal
        modal={verifyPaymentModal}
        handleModal={handleVerifyPaymentModal}
        action={verifyPaymentAction}
        selectVerifiedPayment={selectVerifiedPayment}
        selectedVerifiedPayment={selectedVerifiedPayment}
      />

      <Header />
      {showOtpModal && (
        <OtpModal
          show={showOtpModal}
          handleClose={() => {
            setShowOtpModal(false);
            setOtpCode('');
          }}
          code={otpCode}
          setCode={setOtpCode}
          handleExport={exportDataTable}
        />
      )}
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Ventas de Giftcard: {dataTable?.count}
          </h1>

          <ActionButton
            action={
              giftcardType === giftCardType?.PARTICULAR
                ? () =>
                    history.push(`/module/${transactionTypes.CREATE_GIFTCARD}`)
                : () => handleCreateCodeForm()
            }
            label={'+ Nueva Venta'}
          />
          {/* <ActionButton
            action={() => handleCreateCodeForm()}
            label={'+ Nueva Venta Legacy'}
          /> */}
        </div>
        <div className="breadcrumb-container">
          {/* <div className="exportables-buttons-container"></div> */}
          <div
            className="row"
            style={{ width: '100%', justifyContent: 'space-between' }}
          >
            <div className="col-12 col-md-2">
              <Select
                options={giftCardTypeOptions}
                label={'Tipo'}
                value={giftcardType}
                onChange={handleGiftcardType}
              />
            </div>
            {giftcardType === giftCardType?.PARTICULAR && (
              <>
                <div className="col-12 col-md-2" style={{ marginTop: '23px' }}>
                  <SearchInput
                    placeholder={
                      'Nombre o Apellido, Teléfono, Cédula ,Referencia o Placa'
                    }
                    searchAction={getCodes}
                    value={dataTable?.searchParam}
                    onChange={handleSearchChange}
                    width="50px"
                  />
                </div>
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Desde'}
                  type={'date'}
                  name={'dateFrom'}
                  placeholder={''}
                  onChange={handleSinceDateChange}
                  value={dateFrom}
                  disabled={dataTable?.isLoading}
                />
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Hasta'}
                  type={'date'}
                  name={'dateTo'}
                  placeholder={''}
                  onChange={handleUntilDateChange}
                  value={dateTo}
                  disabled={dataTable?.isLoading}
                />
              </>
            )}
            <div className="col-12 col-md-2">
              <div className="exportables-buttons-container">
                <div style={{ marginTop: '12px' }}>
                  <SelectPerPage
                    label={'Registros por página'}
                    options={itemsPerpage}
                    value={dataTable?.limit}
                    onChange={selectitemsPerpage}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div
                style={{
                  marginTop: '12px',
                  display: 'flex',
                  justifyContent: 'end',
                  flexDirection: 'row',
                  justifySelf: 'end',
                }}
              >
                <ActionButton
                  label={'Exportar'}
                  action={() => {
                    if (
                      ![
                        salesRoles?.SALES_ADMIN,
                        salesRoles?.SALES_ADMIN_AUX,
                        salesRoles?.SALES_DEVELOPER,
                        salesRoles?.SALES_SUPERVISOR,
                      ].includes(authService?.getUserType())
                    ) {
                      showOtp();
                    } else {
                      exportDataTable();
                    }
                  }}
                />
                {giftcardType === giftCardType?.PARTICULAR && (
                  <ActionButton
                    label={'Limpiar Filtros'}
                    action={cleanFilters}
                  />
                )}
              </div>
            </div>
          </div>
          <span></span>
        </div>

        {giftcardType === giftCardType?.RETAIL && (
          <GiftcardTables
            header={giftcardSalesheader}
            data={dataTable}
            handlePageChange={handlePageChange}
            redirectToOrder={redirectToOrder}
            tableRef={tableRef}
            openDetail={openDetail}
            handleEditCodeForm={handleEditCodeForm}
            handleDeleteGiftcardModal={handleDeleteGiftcardModal}
          />
        )}

        {giftcardType === giftCardType?.PARTICULAR && (
          <GiftcardParticularTables
            header={giftcardParticularSalesheader(
              {
                channels: channels,
                codes: codes,
                plans: plans,
                sellers: sellersFilter,
              },
              {
                channelAction: handleChannelsOptions,
                codeAction: handleCodeOptions,
                planAction: handlePlansOptions,
                sellerAction: handleSellerFilter,
              }
            )}
            data={dataTable}
            handlePageChange={handlePageChange}
            redirectToOrder={redirectToOrder}
            tableRef={tableRef}
            openDetail={openDetail}
            handleEditCodeForm={redirectToEdit}
            handleDeleteGiftcardModal={handleDeleteGiftcardModal}
            handleVerifyPaymentModal={handleVerifyPaymentModal}
          />
        )}
      </div>
    </>
  );
};
